import { trackEvent } from '@pm/analytics';
import { Icon, Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';

type GetSupportProps = {
  renewal?: boolean;
};

export const GetSupport = ({ renewal = false }: GetSupportProps) => {
  const { t } = useTranslation('patient-dashboard', {
    keyPrefix: 'GetSupport',
  });
  const supportOptions = t('Options', { returnObjects: true });
  const supportLinks = Object.entries(supportOptions).map(
    ([key, value]: [string, string]) => {
      return {
        text: key,
        href: value,
      };
    },
  );

  // FIXME: What happens if we change the order of the translations???
  // This should be a defined list, not dependent on translation files.
  const renewalSupportList = [
    ...supportLinks.slice(0, 1),
    ...supportLinks.slice(2),
  ];
  const supportList = renewal ? renewalSupportList : supportLinks.slice(1);

  return (
    <div className="pt-[60px]">
      <Text color="contentSubdued" size="headingS">
        {t('Title')}
      </Text>
      <ul className="divide-y">
        {supportList.map(({ text, href }) => (
          <li
            key={text}
            className="py-4 first:pt-6 flex items-center gap-s content-center"
          >
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-xs"
              onClick={() => {
                trackEvent('Button Clicked', {
                  buttonText: text,
                  buttonName: text,
                  targetPath: href,
                  currentPath: window.location.pathname,
                  currentPageName: 'PatientDashboardPage',
                });
              }}
            >
              <Text color="contentSubdued" size="bodyL">
                {text}
              </Text>
              <Icon
                name="open_in_new"
                size="small"
                color="text-content-subdued"
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
